
import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { BookingOptionsStore } from "@fry/booking/lib/booking-items/booking-options.store";
import { FryCommonModule } from "@fry/components/common";
import { InteractiveTableModule } from "@fry/components/common/list/interactive-table";
import { InteractiveTableOptions } from "@fry/components/common/list/interactive-table/interactive-table.component";
import { MaterialModule } from "@fry/components/material";
import { AuthService } from "@fry/lib/auth";
import { ListDefaults, TableService } from "@fry/lib/list";
import { UnboxedModule } from "@fry/ui";
import { switchMap, tap } from "rxjs";

@Component({
    selector: 'eas-available-bookings',
    templateUrl: './booking-available-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    RouterModule,
    FryCommonModule,
    UnboxedModule,
    InteractiveTableModule,
    MaterialModule
],
    providers: [
        TableService,
    ]
})
export class BookingAvailableListComponent {

    private route = inject(ActivatedRoute);
    private bookingOptions = inject(BookingOptionsStore);
    private auth = inject(AuthService)
    tableService = inject(TableService);
    tableLoaded = signal<boolean>(false);


    public tableComponentOptions: InteractiveTableOptions = {
        enableColumns: false,
        enableFilters: true,
        enablePagination: false,
        enableExpand: true,
        enableControls: true,
        expand: {
            label: $localize `Title`,
            type: "modal",
            modalType: "bookingApply"
        }
    };

    ngOnInit() {
        this.route.paramMap.pipe(
            switchMap(params => {
                const user = params.get('user') || this.auth.current.username;
                return this.initializeTable(user);
            })
        ).subscribe({
            error: (error) => {
                console.error(error);
            }
        });
    }

    initializeTable(user: string | undefined) {
        const pageSize = 1000;
        const defaults: ListDefaults = { listType: 'table', engine: 'es', pageSize: pageSize, preserveState: false };
        this.tableComponentOptions.context = { user: user };
        defaults.fixedSearchModel = {
            filter: {
            },
            sort: { sort_on: 'order', sort_order: 'asc' },
            select: ["venue", "date", "window", "status", "free", "price"],
            options: {
                // includeFormFields: false
            },
            context: {
                filter: {},
                user: user
            }
        }
        defaults.searchModel = {
            filter: {
                eligible: 'True',
                windowState: "window"
            },
            sort: { sort_on: 'order', sort_order: 'asc' },
        }
        defaults.featuredFilters = ['text'];
        defaults.quickFilters = ['windowState'];
        defaults.preserveState = false;
        // defaults.quickFilters = ['eligible'];
        return this.tableService.setupWith(this.bookingOptions, defaults, 'available-booking-list')
            .pipe(tap(() => this.tableLoaded.set(true)));
    }
}